class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.priceRangeSubmit = this.querySelector('.js-price-range__submit');
    this.priceRangeSubmit && this.priceRangeSubmit.addEventListener('click', this.onSubmitHandler.bind(this));
    this.debouncedOnSubmit = debounce((event) => {
      if (
        event.target.id == 'SortBy' ||
        event.target.classList.contains('facet-checkbox-sort') ||
        event.target.classList.contains('facet-checkbox') ||
        event.target.closest('.js-facet-apply') ||
        event.target.classList.contains('mobile-facets__checkbox') ||
        event.target.id == 'pagination'
      ) {
        this.onSubmitHandler(event);
      }
    }, 500);
    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener('change', this.debouncedOnSubmit.bind(this));

    this.addEventListener('click', (e) => {
      const applyBtn = e.target.closest('.js-facet-apply');
      if (!applyBtn) return;
      this.onSubmitHandler(e);
      applyBtn.closest('details')?.removeAttribute('open');
    });

    this.addEventListener('click', function (e) {
      const closeEl = e.target.closest('.js-details-close');
      const overlayClick =
        e.target.classList.contains('mobile-facets') || e.target.classList.contains('mobile_sort_container');
      if (!closeEl && !overlayClick) return;

      const details = e.target.closest('details');
      const FacetSortEl = customElements.get('facet-sort');
      if (details?.classList.contains('sort_options') && FacetSortEl?.closeSortPanel) {
        FacetSortEl.closeSortPanel(details);
        return;
      }

      details?.classList.remove('menu-opening');
      details?.removeAttribute('open');
      document.querySelector('body').classList.remove('overflow-hidden-mobile');
      document.querySelector('body').classList.remove('overflow-hidden');
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.addEventListener('click', (event) => {
      const showMore = event.target.closest('.mobile-facets__show-more');
      if (!showMore || !this.contains(showMore)) return;
      event.preventDefault();
      event.stopPropagation();
      const preview = showMore.closest('.mobile-facets__metafields_preview');
      preview?.classList.toggle('open');
      FacetFiltersForm.initDrawerLists(preview);
    });

    FacetFiltersForm.initDrawerLists(this);

    this.facetParams = this.querySelectorAll('.facets__param');
    this.facetParams.forEach((param) => {
      param.addEventListener('click', this.onFilterClick);
    });

    document.addEventListener('click', (event) => {
      const facetsDisclosure = document.querySelector('.mobile-facets__disclosure');
      if (
        facetsDisclosure &&
        facetsDisclosure.hasAttribute('open') &&
        !event.target.closest('.mobile-facets__inner') &&
        !event.target.closest('.facets__wrapper') &&
        !event.target.closest('.mobile-facets__disclosure')
      ) {
        facetsDisclosure.removeAttribute('open');
        document.querySelector('body').classList.remove('overflow-hidden-mobile');
        document.querySelector('body').classList.remove('overflow-hidden');
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static syncMobileSortLabel(label) {
    const text = String(label || '').trim();
    if (!text) return;
    document.querySelectorAll('.facets-bar-mobile .facet-selected-sort').forEach((el) => {
      el.textContent = text;
    });
  }

  static initDrawerLists(root) {
    if (!root) return;
    const maxItems = 5;
    const previews = root.matches?.('.mobile-facets__metafields_preview')
      ? [root]
      : [...root.querySelectorAll('.mobile-facets__metafields_preview')];

    previews.forEach((preview) => {
      const list = preview.querySelector('.mobile-facets__list');
      const btn = preview.querySelector('.mobile-facets__show-more');
      if (!list) return;

      const items = [...list.querySelectorAll('.mobile-facets__item')].filter(
        (item) => !item.classList.contains('hidden'),
      );
      const isOpen = preview.classList.contains('open');
      items.forEach((item, index) => {
        item.classList.toggle('mobile-facets__item--collapsed', !isOpen && index >= maxItems);
      });
      if (btn) {
        btn.classList.toggle('hidden', items.length <= maxItems);
        const labelEl = btn.querySelector('.mobile-facets__show-more-label');
        const more = btn.dataset.labelMore;
        const less = btn.dataset.labelLess;
        if (labelEl && more && less) labelEl.textContent = isOpen ? less : more;
      }
    });
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const productCounts = document.querySelectorAll('.js-product-count');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    productCounts && productCounts.forEach((element) => element.classList.add('loading'));
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}${
        document.documentElement.dataset.shopifyNativeFallback === '1' ? '&view=native' : ''
      }`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').querySelector('.js-product-count').innerHTML;
    const countDesk = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductCountDesktop').innerHTML;
    const countDeskData = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCountDesktop')
      .dataset.result;
    const productCounts = document.querySelectorAll('.js-product-count');
    const countContainerMobile = document.getElementById('ProductCountMobile');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    productCounts &&
      productCounts.forEach((element) => {
        element.innerHTML = count;
        element.classList.remove('loading');
      });
    if (countContainerMobile) countContainerMobile.innerHTML = countDesk;
    if (containerDesktop) {
      containerDesktop.innerHTML = countDesk;
      containerDesktop.dataset.result = countDeskData;
      containerDesktop.classList.remove('hidden');
      containerDesktop.classList.remove('loading');
    }
  }

  static filterGroupKey(element) {
    if (!element) return '';
    const named = element.querySelector('input[name^="filter"], input[name="sort_by"]');
    if (named?.name) {
      if (named.name.includes('price')) return 'filter.v.price';
      return named.name;
    }
    return element.id || element.dataset.index || '';
  }

  static filterGroupsContainer(root) {
    return root?.querySelector('#FacetsWrapperDesktop') || root;
  }

  static syncFilterGroups(scopeSelector, parsedHTML, event) {
    const nextRoot = parsedHTML.querySelector(scopeSelector);
    const currentRoot = document.querySelector(scopeSelector);
    if (!nextRoot || !currentRoot) return;

    const nextContainer = FacetFiltersForm.filterGroupsContainer(nextRoot);
    const currentContainer = FacetFiltersForm.filterGroupsContainer(currentRoot);
    const collectGroups = (container) => {
      const direct = [...container.querySelectorAll(':scope > .js-filter')];
      return direct.length ? direct : [...container.querySelectorAll('.js-filter')];
    };
    const nextGroups = collectGroups(nextContainer);
    const currentGroups = () => collectGroups(currentContainer);
    const activeEl = event?.target?.closest?.(`${scopeSelector} .js-filter`);
    const activeKey = FacetFiltersForm.filterGroupKey(activeEl);
    const nextByKey = new Map(nextGroups.map((el) => [FacetFiltersForm.filterGroupKey(el), el]));
    const countEl = currentContainer.querySelector('#ProductCountDesktop');

    currentGroups().forEach((el) => {
      const key = FacetFiltersForm.filterGroupKey(el);
      if (!nextByKey.has(key)) el.remove();
    });

    nextGroups.forEach((nextEl, index) => {
      const key = FacetFiltersForm.filterGroupKey(nextEl);
      const existing = currentGroups().find((el) => FacetFiltersForm.filterGroupKey(el) === key);
      const isActive = Boolean(key && key === activeKey);

      if (existing && isActive) {
        FacetFiltersForm.renderCounts(nextEl, existing);
      } else if (existing) {
        if (existing.tagName !== nextEl.tagName) {
          existing.replaceWith(nextEl.cloneNode(true));
        } else {
          existing.innerHTML = nextEl.innerHTML;
          existing.className = nextEl.className;
        }
      } else {
        const node = nextEl.cloneNode(true);
        const ref = currentGroups()[index];
        currentContainer.insertBefore(node, ref || countEl || null);
      }

      const synced = currentGroups().find((el) => FacetFiltersForm.filterGroupKey(el) === key);
      if (!synced) return;
      if (nextEl.id) synced.id = nextEl.id;
      if (nextEl.dataset.index) synced.dataset.index = nextEl.dataset.index;
    });

    nextGroups.forEach((nextEl, index) => {
      const key = FacetFiltersForm.filterGroupKey(nextEl);
      const existing = currentGroups().find((el) => FacetFiltersForm.filterGroupKey(el) === key);
      if (!existing || currentGroups()[index] === existing) return;
      currentContainer.insertBefore(existing, currentGroups()[index] || countEl || null);
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    FacetFiltersForm.syncFilterGroups('#FacetFiltersForm', parsedHTML, event);
    FacetFiltersForm.syncFilterGroups('#FacetFiltersPillsForm', parsedHTML, event);
    FacetFiltersForm.syncFilterGroups('#FacetSortFormMobile', parsedHTML, event);

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    FacetFiltersForm.syncColorSwatchContrast();

    const keepOpen =
      event?.target?.matches?.('input[type="checkbox"], input[type="radio"]') ||
      event?.target?.classList?.contains('mobile-facets__checkbox');
    if (!keepOpen) return;

    const activeFilter = event.target.closest('.js-filter');
    const openDisclosure = activeFilter?.closest?.('.facets__disclosure') || activeFilter;
    if (openDisclosure?.classList?.contains('facets__disclosure')) {
      openDisclosure.setAttribute('open', '');
    }
  }

  /**
   * Purple check on light swatches, white on dark (WCAG relative luminance).
   * Image swatches are left alone (default white check).
   */
  static syncColorSwatchContrast(root = document) {
    root.querySelectorAll('.facets__color .facets__item_label_icon').forEach((el) => {
      const bg = el.style.background || el.style.backgroundColor || '';
      if (!bg || /^url\(/i.test(bg.trim()) || /url\(/i.test(bg)) {
        el.classList.remove('facets__item_label_icon--light', 'facets__item_label_icon--white');
        return;
      }
      const light = FacetFiltersForm.isLightCssColor(bg);
      el.classList.toggle('facets__item_label_icon--light', light);
      el.classList.remove('facets__item_label_icon--white');
    });
  }

  static isLightCssColor(input, threshold = 0.55) {
    const rgb = FacetFiltersForm.parseCssColorToRgb(input);
    if (!rgb) return false;
    const [r, g, b] = rgb.map((c) => {
      const s = c / 255;
      return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
    });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b > threshold;
  }

  static parseCssColorToRgb(input) {
    if (input == null) return null;
    let s = String(input).trim();
    if (!s || /^url\(/i.test(s)) return null;
    s = s
      .split(';')[0]
      .replace(/^background(-color)?\s*:\s*/i, '')
      .trim();
    // style.background may be "rgb(...) none repeat ..."
    const urlIdx = s.search(/\burl\(/i);
    if (urlIdx === 0) return null;
    if (urlIdx > 0) s = s.slice(0, urlIdx).trim();

    let m = s.match(/#([0-9a-f]{3}|[0-9a-f]{6})\b/i);
    if (m) {
      let h = m[1];
      if (h.length === 3) h = [...h].map((c) => c + c).join('');
      return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
    }

    m = s.match(/rgba?\(\s*([\d.]+)\s*[,/ ]\s*([\d.]+)\s*[,/ ]\s*([\d.]+)/i);
    if (m) return [Number(m[1]), Number(m[2]), Number(m[3])];
    return null;
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (activeFacetsElement?.querySelector('.active-facets-heading') != null) {
        if (activeFacetsElement.querySelector('.active-facets__container').childElementCount >= 1) {
          activeFacetsElement.querySelector('.active-facets-heading').classList.remove('hidden');
        } else {
          activeFacetsElement.querySelector('.active-facets-heading').classList.add('hidden');
        }
      }
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileFormNew = html.querySelector('#FacetFiltersFormMobile');
    const mobileFormCurrent = document.getElementById('FacetFiltersFormMobile');
    if (mobileFormNew && mobileFormCurrent) {
      const mobileMainNew = mobileFormNew.querySelector('.mobile-facets__main');
      const mobileMainCurrent = mobileFormCurrent.querySelector('.mobile-facets__main');
      if (mobileMainNew && mobileMainCurrent) {
        mobileMainCurrent.innerHTML = mobileMainNew.innerHTML;
        FacetFiltersForm.initDrawerLists(mobileMainCurrent);
      }

      const countNew = mobileFormNew.querySelector('.mobile-facets__heading-count');
      const countCurrent = document.querySelector('#FacetFiltersFormMobile .mobile-facets__heading-count');
      if (countNew && countCurrent) countCurrent.replaceWith(countNew.cloneNode(true));
    }

    const filtersCountNew = html.querySelector('#FacetFiltersCount');
    const filtersCountCurrent = document.getElementById('FacetFiltersCount');
    if (filtersCountNew && filtersCountCurrent) {
      filtersCountCurrent.replaceWith(filtersCountNew.cloneNode(true));
    }

    const facetsContainer = document.getElementById('FacetFiltersFormMobile')?.closest('.facets-container');
    facetsContainer?.querySelector('menu-drawer')?.bindEvents();

    FacetFiltersForm.syncMobileSortLabel(
      html.querySelector('.facets-bar-mobile .facet-selected-sort')?.textContent?.trim(),
    );
  }

  static renderCounts(source, target) {
    if (!source || !target) return;

    const replaceAll = (selector) => {
      const next = source.querySelectorAll(selector);
      target.querySelectorAll(selector).forEach((el, index) => {
        if (next[index]) el.outerHTML = next[index].outerHTML;
      });
    };

    replaceAll('.facets__selected');
    replaceAll('.active_value_count');
    replaceAll('.active_value_count_button');

    const sourceSummary = source.querySelector('.facets__summary');
    const targetSummary = target.querySelector('.facets__summary');
    if (sourceSummary && targetSummary) {
      const label = sourceSummary.getAttribute('aria-label');
      if (label != null) targetSummary.setAttribute('aria-label', label);
      else targetSummary.removeAttribute('aria-label');
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    const isDesktop = window.innerWidth >= 750;
    const hasDedicatedDesktopSort = [...sortFilterForms].some(
      (form) => form.id === 'FacetSortForm' || form.id === 'FacetSortDrawerForm',
    );

    sortFilterForms.forEach((form) => {
      const shouldProcessForm = isDesktop
        ? form.id === 'FacetFiltersForm' ||
          form.id === 'FacetSortForm' ||
          form.id === 'FacetSortDrawerForm' ||
          (form.id === 'FacetSortFormMobile' && !hasDedicatedDesktopSort)
        : form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortFormMobile';

      if (shouldProcessForm) {
        if (isDesktop) {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => el.remove());
        }

        // Handle price filter logic
        const minInput = form.querySelector('input[name="filter.v.price.gte"]');
        const maxInput = form.querySelector('input[name="filter.v.price.lte"]');

        if (minInput && maxInput) {
          const maxRange = maxInput.getAttribute('max') || maxInput.getAttribute('placeholder');

          if (minInput.value == '0' && maxInput.value == maxRange) {
            minInput.disabled = true;
            maxInput.disabled = true;

            const params = this.createSearchParams(form);
            if (params.length > 0) {
              forms.push(params);
            }

            minInput.disabled = false;
            maxInput.disabled = false;
          } else {
            const params = this.createSearchParams(form);
            if (params.length > 0) {
              forms.push(params);
            }
          }
        } else {
          const params = this.createSearchParams(form);
          if (params.length > 0) {
            forms.push(params);
          }
        }
      }
    });
    // close sort details drawer before render the page
    const sortDetailsSubmitted = event.target.closest('.js-sort-details');
    if (sortDetailsSubmitted) {
      const checked = sortDetailsSubmitted.querySelector('.facet-checkbox-sort:checked');
      FacetFiltersForm.syncMobileSortLabel(checked?.dataset.name);
      customElements.get('facet-sort')?.closeSortPanel?.(sortDetailsSubmitted);
    }

    // Filter out any empty strings before joining
    const filteredForms = forms.filter((form) => form.length > 0);
    FacetFiltersForm.renderPage(filteredForms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  #abortController;
  connectedCallback() {
    this.#abortController = new AbortController();
    this.init();
    this.attachEventListeners();
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  init() {
    this.rangeLowerBound = this.querySelector('.js-range__min');
    this.rangeHigherBound = this.querySelector('.js-range__max');
    this.textInputLowerBound = this.querySelector('.js-range-input__min');
    this.textInputHigherBound = this.querySelector('.js-range-input__max');
    this.facetFiltersForm = this.closest('facet-filters-form');
  }

  attachEventListeners() {
    this.textInputLowerBound.addEventListener('change', this.handleTextInputChange.bind(this, 'min'), {
      signal: this.#abortController.signal,
    });
    this.textInputHigherBound.addEventListener('change', this.handleTextInputChange.bind(this, 'max'), {
      signal: this.#abortController.signal,
    });

    this.rangeLowerBound.addEventListener('change', this.handleRangeChange.bind(this, 'min'), {
      signal: this.#abortController.signal,
    });
    this.rangeHigherBound.addEventListener('change', this.handleRangeChange.bind(this, 'max'), {
      signal: this.#abortController.signal,
    });

    this.rangeLowerBound.addEventListener('input', this.handleRangeInput.bind(this, 'min'), {
      signal: this.#abortController.signal,
    });
    this.rangeHigherBound.addEventListener('input', this.handleRangeInput.bind(this, 'max'), {
      signal: this.#abortController.signal,
    });
  }

  handleTextInputChange(type, event) {
    event.preventDefault();
    const isMin = type === 'min';
    const textInput = isMin ? this.textInputLowerBound : this.textInputHigherBound;
    const otherTextInput = isMin ? this.textInputHigherBound : this.textInputLowerBound;
    const rangeInput = isMin ? this.rangeLowerBound : this.rangeHigherBound;

    textInput.value = isMin
      ? Math.max(
          Math.min(parseInt(textInput.value), parseInt(otherTextInput.value || textInput.max) - 1),
          textInput.min,
        )
      : Math.min(
          Math.max(parseInt(textInput.value), parseInt(otherTextInput.value || textInput.min) + 1),
          textInput.max,
        );

    rangeInput.value = textInput.value;
    this.updateRangeStyle(rangeInput, type);

    if (this.facetFiltersForm) {
      this.facetFiltersForm.onSubmitHandler(event);
    }
  }

  handleRangeChange(type, event) {
    event.stopPropagation();
    const textInput = type === 'min' ? this.textInputLowerBound : this.textInputHigherBound;
    textInput.value = event.target.value;
    textInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  handleRangeInput(type, event) {
    const isMin = type === 'min';
    const textInput = isMin ? this.textInputLowerBound : this.textInputHigherBound;
    const otherTextInput = isMin ? this.textInputHigherBound : this.textInputLowerBound;

    event.target.value = isMin
      ? Math.min(parseInt(event.target.value), parseInt(otherTextInput.value || event.target.max) - 1)
      : Math.max(parseInt(event.target.value), parseInt(otherTextInput.value || event.target.min) + 1);

    textInput.value = event.target.value;
    this.updateRangeStyle(event.target, type);
  }

  updateRangeStyle(rangeInput, type) {
    const percentage = (parseInt(rangeInput.value) / parseInt(rangeInput.max)) * 100;
    rangeInput.parentElement.style.setProperty(`--range-${type}`, `${percentage}%`);
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if (facetLink) {
      facetLink.setAttribute('role', 'button');
      facetLink.addEventListener('click', this.closeFilter.bind(this));
      facetLink.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
      });
    }
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form && form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetsBar extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    if (this.dataset.bound === 'true') return;
    this.dataset.bound = 'true';

    this.addEventListener('click', (event) => {
      const param = event.target.closest('.facets__param:not(.toggle-switch)');
      if (!param || !this.contains(param)) return;
      this.onFacetClick(event);
    });

    this.addEventListener('change', (event) => {
      if (!event.target.matches('.toggle-switch input[type="checkbox"]')) return;
      this.onToggleChange(event);
    });
  }

  onFacetClick(event) {
    if (window.innerWidth >= 750) return;

    let facetDisclosure = document.querySelector('.mobile-facets__disclosure');
    if (facetDisclosure) {
      facetDisclosure.classList.add('menu-opening');
      facetDisclosure.setAttribute('open', '');
      if (window.innerWidth < 750) {
        document.querySelector('body').classList.add('overflow-hidden-mobile');
      } else {
        document.querySelector('body').classList.add('overflow-hidden');
      }
    }
  }

  onToggleChange(event) {
    const value = event.target.value;
    const isChecked = event.target.checked;

    const targetForm = document.getElementById('FacetFiltersFormMobile');
    const targetCheckbox = targetForm?.querySelector(`input[value="${value}"]`);

    if (!targetCheckbox) return;

    targetCheckbox.checked = isChecked;

    const facetFiltersForm = targetForm.parentElement;

    const simulatedEvent = {
      preventDefault: () => {},
      target: targetCheckbox,
    };

    facetFiltersForm?.onSubmitHandler(simulatedEvent);
  }
}

customElements.define('facets-bar', FacetsBar);

class FacetSort extends HTMLElement {
  static #outsideClickHandlers = new WeakMap();
  static MOBILE_BREAKPOINT = 750;

  constructor() {
    super();
    this.addEventListener('click', this.onSortClick);
  }

  onSortClick(event) {
    event.preventDefault();
    const sortRoot =
      this.closest('.constructor-browse-shell, .facets-vertical')?.querySelector('.mobile-facets__wrapper') ||
      document.querySelector('.facets-container .mobile-facets__wrapper');
    const sortDisclosure = sortRoot?.querySelector('.sort_options');
    if (!sortDisclosure) return;

    if (sortDisclosure.hasAttribute('open')) {
      FacetSort.closeSortPanel(sortDisclosure);
      return;
    }

    sortDisclosure.setAttribute('open', '');
    sortDisclosure.classList.add('menu-opening');
    FacetSort.syncTriggerExpanded(true);

    if (window.innerWidth < FacetSort.MOBILE_BREAKPOINT) {
      document.body.classList.add('overflow-hidden-mobile');
    } else {
      document.body.classList.add('overflow-hidden');
    }
    requestAnimationFrame(() => FacetSort.bindSortOutsideClick(sortDisclosure));
  }

  static clearMobileSortPanel(sortDisclosure) {
    const panel = sortDisclosure?.querySelector('.facets__display-vertical');
    if (!panel) return;
    panel.style.removeProperty('--sort-panel-top');
    panel.style.removeProperty('--sort-panel-left');
    panel.style.removeProperty('--sort-panel-width');
  }

  static bindSortOutsideClick(sortDisclosure) {
    FacetSort.unbindSortOutsideClick(sortDisclosure);
    const handler = (event) => {
      if (!sortDisclosure.hasAttribute('open')) return;
      if (event.target.closest('facet-sort')) return;
      const onMobile = window.innerWidth < FacetSort.MOBILE_BREAKPOINT;
      if (onMobile && event.target.closest('.sort_options .facets-wrap')) return;
      if (!onMobile && event.target.closest('.sort_options')) return;
      FacetSort.closeSortPanel(sortDisclosure);
    };
    FacetSort.#outsideClickHandlers.set(sortDisclosure, handler);
    document.addEventListener('click', handler, true);
  }

  static bindMobileSortOutsideClick(sortDisclosure) {
    FacetSort.bindSortOutsideClick(sortDisclosure);
  }

  static unbindSortOutsideClick(sortDisclosure) {
    const handler = FacetSort.#outsideClickHandlers.get(sortDisclosure);
    if (!handler) return;
    document.removeEventListener('click', handler, true);
    FacetSort.#outsideClickHandlers.delete(sortDisclosure);
  }

  static unbindMobileSortOutsideClick(sortDisclosure) {
    FacetSort.unbindSortOutsideClick(sortDisclosure);
  }

  static syncTriggerExpanded(expanded) {
    document.querySelectorAll('facet-sort [aria-expanded]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  static closeSortPanel(sortDisclosure) {
    if (!sortDisclosure) return;
    FacetSort.unbindSortOutsideClick(sortDisclosure);
    FacetSort.clearMobileSortPanel(sortDisclosure);
    sortDisclosure.classList.remove('menu-opening');
    sortDisclosure.removeAttribute('open');
    FacetSort.syncTriggerExpanded(false);
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile');
  }
}

customElements.define('facet-sort', FacetSort);

document.addEventListener(
  'toggle',
  (event) => {
    const details = event.target;
    if (!details?.classList?.contains('sort_options')) return;
    if (details.open) {
      FacetSort.bindSortOutsideClick(details);
      FacetSort.syncTriggerExpanded(true);
    } else {
      FacetSort.syncTriggerExpanded(false);
    }
  },
  true,
);

/* Desktop filter dropdowns use filter:drop-shadow, which breaks summary::before overlays */
document.addEventListener('click', (event) => {
  if (window.innerWidth < 750) return;
  document.querySelectorAll('.facets__disclosure[open]:not(.sort_options)').forEach((details) => {
    if (event.target.closest('.facets__disclosure') === details) return;
    details.classList.remove('menu-opening');
    details.removeAttribute('open');
  });
});

document.addEventListener('DOMContentLoaded', () => {
  FacetFiltersForm.syncColorSwatchContrast();
});
